var map = {
	"./arabic-w.svg": "5435",
	"./armenian-w.svg": "aef5",
	"./bengali-w.svg": "3e5d",
	"./chinese-w.svg": "68c5",
	"./georgian-w.svg": "3608",
	"./greek-full-w.svg": "6960",
	"./greek-w.svg": "5820",
	"./hebrew-w.svg": "9560",
	"./indian-w.svg": "4473",
	"./japanese-w.svg": "bdba",
	"./korean-w.svg": "feca",
	"./latin-w.svg": "cc31",
	"./thai-w.svg": "7333"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "959f";